import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import {
  NgbCollapseModule,
  NgbDropdownModule,
} from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { AuthService } from "../../services/auth.service";

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "ni-chart-bar-32 text-primary",
    class: "",
  },
  {
    path: "/compras",
    title: "Últimos compras",
    icon: "ni-basket text-primary",
    class: "",
  },
  {
    path: "/company-profile",
    title: "Perfil",
    icon: "ni-single-02 text-primary",
    class: "",
  },
  {
    path: "/cashback",
    title: "Cashback",
    icon: "ni-check-bold text-primary",
    class: "",
  },
  {
    path: "/cashback-settings",
    title: "Configurações",
    icon: "ni-settings-gear-65 text-primary",
    class: "",
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
  imports: [CommonModule, RouterModule, NgbCollapseModule, NgbDropdownModule],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[] = [];
  public isCollapsed = true;
  public company: any = {};

  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
  }

  logout() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Deseja sair?",
        text: "Você vai fazer logout!!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, sair!",
        cancelButtonText: "Não, cancelar!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          try {
            this.authService.logout();
          } catch (error) {
            console.error(error);
            Swal.fire(
              "Erro!",
              "Não foi possível sair. Tente novamente mais tarde.",
              "error"
            );
          }
        }
      });
  }
}
